<template>
  <div id="uploadModelsModal" class="modal">
    <!-- Modal content -->
    <v-card width="400px">
      <v-card-title height="30">
        <span>Upload Model</span>
        <v-spacer></v-spacer>
        <v-icon @click="onCloseClicked()">close fas fa-times</v-icon>
      </v-card-title>
      <v-card-text class="g-4">
        <div class="modal-row">
          <v-text-field
            outlined
            dense
            hide-details
            clearable
            v-virtual-keyboard
            height="40px"
            label="Model Name"
            class="v-min-input"
            placeholder="Enter Name..."
            v-model="modelToUpload.name">
          </v-text-field>
        </div>
        <div class="modal-row">
          <v-text-field
            outlined
            dense
            hide-details
            clearable
            v-virtual-keyboard
            height="40px"
            label="Model Version"
            class="v-min-input"
            placeholder="Enter Model Version..."
            v-model="modelToUpload.version">
          </v-text-field>
        </div>
        <div class="modal-row toggle-row">
          <label>Is SVF2</label>
          <CustomCheckbox
            :is_checked="modelToUpload.isSvf2"
            :name="'isSvf2'"
            @check_changed="modelToUpload.isSvf2 = $event.value"></CustomCheckbox>
        </div>

        <div class="modal-row toggle-row">
          <label>Upload in chunks</label>
          <CustomCheckbox
            :is_checked="modelToUpload.uploadInChunks"
            :name="'uploadInChunks'"
            @check_changed="modelToUpload.uploadInChunks = $event.value"></CustomCheckbox>
        </div>

        <div class="modal-row">
          <div v-if="selectedFile" style="padding-top: 10px">{{ selectedFile.name }}</div>
          <div v-if="!selectedFile" style="padding-top: 10px">No File Selected</div>
          <input
            type="file"
            style="display: none"
            id="browseModelFile"
            @change="onFileChanged($event)" />
        </div>
        <div class="modal-row">
          <v-btn color="info" @click="broswe()">Select File</v-btn>
        </div>
        <progress
          style="width: 100%; height: 20px"
          v-if="isUploading"
          min="0"
          :max="maxProgress_modls"
          step="1"
          :value="progress_models"></progress>

        <v-card-actions class="d-flex g-4">
          <v-btn style="flex: 1" @click="onCloseClicked()">Close</v-btn>
          <v-btn style="flex: 1" color="primary" @click="uploadForgeModel()">Upload</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { ForgeModelVersion } from '@/scripts/js/forgeModels';
  import CustomCheckbox from '@/components/common/customCheckbox.vue';
  import { log, warn, error } from '@/utils/debugLogger';
  export default {
    name: 'UploadModels',
    components: {
      CustomCheckbox,
    },
    props: ['assetId'],
    data() {
      return {
        modelToUpload: new ForgeModelVersion(),
        progress_models: 0,
        selectedFile: null,
        isUploading: false,
        maxProgress_modls: 100,
      };
    },
    methods: {
      onFileChanged(event) {
        if (event.target.files.length == 0) {
          this.selectedFile = null;
          return;
        }
        this.selectedFile = event.target.files[0];
      },
      broswe() {
        document.getElementById('browseModelFile').click();
      },
      onCloseClicked() {
        document.getElementById('uploadModelsModal').style.display = 'none';
      },
      uploadForgeModel() {
        log('uploadModels', 'uploadInChunks:', this.modelToUpload.uploadInChunks);
        if (!this.selectedFile) {
          this.$dialog.notify.warning('Please select file first.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        if (!this.modelToUpload.name) {
          this.$dialog.notify.warning('Please Enter the model name.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        if (this.$store.state.uploadedModels.some((o) => o.name == this.modelToUpload.name)) {
          this.$dialog.notify.warning('Name is already existing, please change a unique name.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        if (!this.modelToUpload.version) {
          this.$dialog.notify.warning('Please Enter the model version.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        this.progress_models = 0;
        this.maxProgress_modls = 100;
        this.isUploading = true;

        var onProgress = (progress, maxProgress) => {
          this.progress_models = progress;
          this.maxProgress_modls = maxProgress;
        };
        this.$store.state.forgeService.uploadVersionToAsset(
          !!this.modelToUpload.uploadInChunks,
          this.assetId,
          this.modelToUpload,
          this.selectedFile,
          onProgress,
          (version) => {
            this.isUploading = false;
            this.$emit('uploadSuccess', version);
            this.$emit('dispose3DViewer');
            this.modelToUpload = new ForgeModelVersion();
            document.getElementById('uploadModelsModal').style.display = 'none';
            this.onCloseClicked();
            this.$dialog.notify.success('Uploaded successfully, translating in progress...', {
              position: 'top-right',
              timeout: 3000,
            });
          },
          (err) => {
            log('uploadModels', 'upload error:', err);
            this.isUploading = false;
            this.$dialog.notify.warning('Uploading failed, please try again later.', {
              position: 'top-right',
              timeout: 3000,
            });
          },
        );
      },
    },
  };
</script>

<style>
  #uploadModelsModal .modal-content {
    height: 400px;
  }

  .toggle-row {
    display: flex;
    align-items: center;
  }

  .g-4 {
    gap: 1rem;
  }
</style>
